import { useIntl, FormattedMessage } from 'react-intl';

import { Icon } from 'cosmos-components';

import msg from './retrieveSelfCheckInMessages';
import {
    StyledContentWrapper,
    StyledContent,
} from './retrieveSelfCheckIn.component';

export const LandingText = () => {
    const intl = useIntl();
    return (
        <StyledContentWrapper>
            <StyledContent>
                <b>{intl.formatMessage(msg.content.welcomeToAuNz)}</b>
            </StyledContent>
            <StyledContent>
                {intl.formatMessage(msg.content.checkInOpensAuNz)}
            </StyledContent>
            <StyledContent />
            <StyledContent>
                <FormattedMessage
                    {...msg.content.headsUp}
                    values={{
                        headsUpBoldText: intl.formatMessage(
                            msg.content.headsUpBoldText,
                        ),
                        minutes: 30,
                    }}
                />
            </StyledContent>
            <StyledContent>
                <hr />
            </StyledContent>
            <StyledContent>
                <b>{intl.formatMessage(msg.content.duringCheckIn)}</b>
                <ul>
                    <li>
                        {intl.formatMessage(msg.content.contactDetails)}
                    </li>
                    <li>{intl.formatMessage(msg.content.licenceDetails)}</li>
                    <li>{intl.formatMessage(msg.content.additionalDrivers)}</li>
                    <li>{intl.formatMessage(msg.content.reviewLiabilityCover)}</li>
                    <li>{intl.formatMessage(msg.content.enterTimeOfArrival)}</li>
                    <li>{intl.formatMessage(msg.content.demoVideos)}</li>
                    <li>{intl.formatMessage(msg.content.travelExtras)}</li>
                    <li>{intl.formatMessage(msg.content.outstanding)}</li>
                    <li>{intl.formatMessage(msg.content.insurancePolicy)}</li>
                </ul>
            </StyledContent>
            <StyledContent>
                <hr />
            </StyledContent>
            <StyledContent>
                <Icon name="tickSquared" color="green" />
                {intl.formatMessage(msg.content.tip)}
            </StyledContent>
            <StyledContent />
            <StyledContent>
                {intl.formatMessage(msg.content.subTextUs)}
            </StyledContent>
        </StyledContentWrapper>
    );
};
